import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPDateTimeField } from '../components/Table/fields/SPDateTimeField';

export const guideHaveTime: SchemaWithClient<any> = {
  name: 'Staff Work Time',
  pluralName: 'Staff Work Time',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      required: false,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
      hide: true,
    },
    from: {
      name: 'From',
      fieldRenderer: SPDateField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'date',
    },
    to: {
      name: 'To',
      fieldRenderer: SPDateField,
      slidePaneFieldRenderer: SPDateTimeField,
      fieldType: 'date',
    },
    user: {
      name: 'User',
      fieldRenderer: SelectField.tableAdapter(enumItems.user),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.user),
      url: enumItems.user.client.getAllPath,
      tempSchema: enumItems.user,
      switchboard: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/guide-have-times'),
};
